// extracted by mini-css-extract-plugin
module.exports = {"toggle":"Toogle_toggle__3KnFY","input":"Toogle_input__U9zWB","handle":"Toogle_handle__MMxoZ"};